export enum LoaderActions {
  SLOT_LOADER = 'SLOT_LOADER',
  SUMMARY_PRICES_LOADER = 'SUMMARY_PRICES_LOADER',
  ADDING_OPTIONAL_NUMBER = 'ADDING_OPTIONAL_NUMBER',
  OPTIONAL_INTERNET = 'OPTIONAL_INTERNET',
  MODAL_LOADER = 'MODAL_LOADER'
}
